import * as React from 'react';

import classNames from 'classnames';

import { Link } from '@ui';

import { IMainMenuUserProps } from './types';

import * as s from './MainMenuUser.scss';

export const MainMenuUser: React.FC<IMainMenuUserProps> = ( props: IMainMenuUserProps ) => {
	const {
		className,
		name,
		link,
		avatar,
		onClick,
	} = props;

	const onLinkClick = () => {
		if (link && onClick) {
			onClick();
		}
	};

	return (
		<Link onClick={onLinkClick} to={link} className={classNames(s.block, className)} isSimpleLink>
			<span className={s.avatar} style={{ backgroundImage: `url(${avatar})` }}/>
			<span className={s.title}>{name}</span>
		</Link>
	);
};

MainMenuUser.defaultProps = {
	name: '',
	link: '',
	avatar: '',
};
